import React from 'react';
import ArrowIcon from '../assets/images/Arrow'; // adjust path as needed

interface PrimaryBtnProps {
  label: string;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const Button = ({ label, disabled, className = '', onClick }: PrimaryBtnProps) => {
  return (
    <button className={`primary-btn ${className}`} disabled={disabled} onClick={onClick}>
      <span>{label}</span>
      <ArrowIcon />
    </button>
  );
};

export default Button;
